Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

// js/sections/at-mega-menu.js
const atHandleMenuToggle = (event) => {
  const button = event.currentTarget;
  const targetSelector = button.getAttribute('data-target');
  const atMegaMenu = button.closest('.at-mega-menu');

  if (atMegaMenu) {
    const targetMenu = atMegaMenu.querySelector(targetSelector);

    if (targetMenu) {
      const isMenuAlreadyActive = targetMenu.classList.contains('show');

      atMegaMenu.querySelectorAll('.child-submenu__nav.show').forEach(menu => {
        if (menu !== targetMenu) {
          menu.classList.remove('show');
          const relatedButton = atMegaMenu.querySelector(`[data-target="#${menu.id}"]`);
          if (relatedButton) {
            relatedButton.classList.remove('active');
          }
        }
      });
      
      if (!isMenuAlreadyActive) {
        targetMenu.classList.add('show');
        button.classList.add('active');
      }
    }
  }
};

const atHandleTabToggle = (event) => {
  const button = event.currentTarget;
  const targetSelector = button.getAttribute('data-target');
  const atMegaMenu = button.closest('.at-mega-menu');

  if (atMegaMenu) {
    const targetTab = atMegaMenu.querySelector(targetSelector);
    
    if (targetTab) {
      atMegaMenu.querySelectorAll('.product-tab.show').forEach(tab => {
        if (tab !== targetTab) {
          tab.classList.remove('show');
          const relatedButton = atMegaMenu.querySelector(`[data-target="#${tab.id}"]`);
          if (relatedButton) {
            relatedButton.classList.remove('active');
          }
        }
      });

      const isTabAlreadyActive = targetTab.classList.contains('show');
      if (!isTabAlreadyActive) {
        targetTab.classList.add('show');
        button.classList.add('active');
      }
    }
  }
};

const handleMobileTabToggle = (event) => {
  const button = event.currentTarget;
  const targetSelector = button.getAttribute('data-target');
  const atPanelWrapper = button.closest('.at-panel__wrapper');

  if (atPanelWrapper) {
    const targetTab = atPanelWrapper.querySelector(targetSelector);

    if (targetTab) {
      atPanelWrapper.querySelectorAll('.product-tab.show').forEach(tab => {
        if (tab !== targetTab) {
          tab.classList.remove('show');
          const relatedButton = atPanelWrapper.querySelector(`[data-target="#${tab.id}"]`);
          if (relatedButton) {
            relatedButton.classList.remove('active');
          }
        }
      });

      if (!targetTab.classList.contains('show')) {
        targetTab.classList.add('show');
        button.classList.add('active');
      }
    }
  }
};

const handleMobileMegaMenuToggle = (event) => {
  const button = event.currentTarget;
  const atChildToggleWrapper = button.closest('.child-toggle-wrapper');
  
  if (atChildToggleWrapper) {
    const toggleWrapper = atChildToggleWrapper.querySelector('.at-toggle__wrapper');
    
    if (toggleWrapper) {
      const allToggleWrappers = document.querySelectorAll('.at-toggle__wrapper');
      allToggleWrappers.forEach(wrapper => {
        if (wrapper !== toggleWrapper) {
          wrapper.classList.add('hidden');
          const associatedButton = wrapper.closest('.child-toggle-wrapper').querySelector('button');
          if (associatedButton) {
            associatedButton.setAttribute('aria-expanded', 'false');
          }
        }
      });
      
      toggleWrapper.classList.toggle('hidden');
      
      const ariaExpanded = toggleWrapper.classList.contains('hidden') ? 'false' : 'true';
      button.setAttribute('aria-expanded', ariaExpanded);
    }
  }
};

const atHandleCollectionTabToggle = (event) => {
  const button = event.currentTarget;
  const targetSelector = button.getAttribute('data-target');
  const atCollectionTab = button.closest('.shopify-section--at-products-tabs-collection');

  if (atCollectionTab) {
    const targetTab = atCollectionTab.querySelector(targetSelector);
    
    if (targetTab) {
      atCollectionTab.querySelectorAll('.product-tab.show').forEach(tab => {
        if (tab !== targetTab) {
          tab.classList.remove('show');
          const relatedButton = atCollectionTab.querySelector(`[data-target="#${tab.id}"]`);
          if (relatedButton) {
            relatedButton.classList.remove('active');
          }
        }
      });

      const isTabAlreadyActive = targetTab.classList.contains('show');
      if (!isTabAlreadyActive) {
        targetTab.classList.add('show');
        button.classList.add('active');
      }
    }
  }
};

const attachEventListeners = () => {
  const atMegaMenus = document.querySelectorAll('.at-mega-menu');

  atMegaMenus.forEach(atMegaMenu => {
    atMegaMenu.querySelectorAll('.sub-parent-toggle').forEach(button => {
      button.addEventListener('mouseenter', atHandleMenuToggle); // click
    });

    atMegaMenu.querySelectorAll('.product-tabs-toggle-wrapper .product-tab-toggle').forEach(button => {
      button.addEventListener('click', atHandleTabToggle);
    });
  });

  document.querySelectorAll('.at-panel__wrapper').forEach(panelWrapper => {
    panelWrapper.querySelectorAll('.product-tab-toggle').forEach(button => {
      button.addEventListener('click', handleMobileTabToggle);
    });
    
    panelWrapper.querySelectorAll('.at-menu-toggle-button').forEach(button => {
      button.addEventListener('click', handleMobileMegaMenuToggle);
    });
  });

  const atCollectionProductTabs = document.querySelectorAll('.shopify-section--at-products-tabs-collection');
  atCollectionProductTabs.forEach(atCollectionProductTab => {
    atCollectionProductTab.querySelectorAll('.product-tabs-toggle-wrapper .product-tab-toggle').forEach(button => {
      button.addEventListener('click', atHandleCollectionTabToggle);
    });
  });
};

const setDefaultActiveMenu = () => {
  const atMegaMenus = document.querySelectorAll('.at-mega-menu');

  atMegaMenus.forEach(atMegaMenu => {
    const firstParentButton = atMegaMenu.querySelector('.sub-parent-toggle');

    if (firstParentButton) {
      const firstMenuSelector = firstParentButton.getAttribute('data-target');
      const firstMenu = atMegaMenu.querySelector(firstMenuSelector);

      if (firstMenu) {
        const allButtons = atMegaMenu.querySelectorAll('.sub-parent-toggle');
        const allMenus = atMegaMenu.querySelectorAll('.child-submenu__nav');

        allButtons.forEach(btn => btn.classList.remove('active'));
        allMenus.forEach(m => m.classList.remove('show'));

        firstParentButton.classList.add('active');
        firstMenu.classList.add('show');
      }
    }
  });
};

const setDefaultActiveTab = () => {
  const atMegaMenus = document.querySelectorAll('.at-mega-menu');

  atMegaMenus.forEach(atMegaMenu => {
    const firstTabButton = atMegaMenu.querySelector('.product-tabs-toggle-wrapper .product-tab-toggle');

    if (firstTabButton) {
      const firstTabSelector = firstTabButton.getAttribute('data-target');
      const firstTab = atMegaMenu.querySelector(firstTabSelector);

      if (firstTab) {
        const allTabButtons = atMegaMenu.querySelectorAll('.product-tabs-toggle-wrapper .product-tab-toggle');
        const allTabs = atMegaMenu.querySelectorAll('.product-tabs-wrapper .product-tab');

        allTabButtons.forEach(btn => btn.classList.remove('active'));
        allTabs.forEach(tab => tab.classList.remove('show'));

        firstTabButton.classList.add('active');
        firstTab.classList.add('show');
      }
    }
  });
};

const setMobileDefaultActiveTab = () => {
  document.querySelectorAll('.at-panel__wrapper').forEach(panelWrapper => {
    const firstTabButton = panelWrapper.querySelector('.product-tab-toggle');

    if (firstTabButton) {
      const firstTabSelector = firstTabButton.getAttribute('data-target');
      const firstTab = panelWrapper.querySelector(firstTabSelector);

      if (firstTab) {
        const allTabButtons = panelWrapper.querySelectorAll('.product-tab-toggle');
        const allTabs = panelWrapper.querySelectorAll('.product-tab');

        allTabButtons.forEach(btn => btn.classList.remove('active'));
        allTabs.forEach(tab => tab.classList.remove('show'));

        firstTabButton.classList.add('active');
        firstTab.classList.add('show');
      }
    }
  });
};

const setDefaultCollectionProductActiveTab = () => {
  const atCollectionTabs = document.querySelectorAll('.shopify-section--at-products-tabs-collection');
  atCollectionTabs.forEach(atCollectionTab => {
    const firstTabButton = atCollectionTab.querySelector('.product-tabs-toggle-wrapper .product-tab-toggle');

    if (firstTabButton) {
      const firstTabSelector = firstTabButton.getAttribute('data-target');
      const firstTab = atCollectionTab.querySelector(firstTabSelector);

      if (firstTab) {
        const allTabButtons = atCollectionTab.querySelectorAll('.product-tabs-toggle-wrapper .product-tab-toggle');
        const allTabs = atCollectionTab.querySelectorAll('.product-tabs-wrapper .product-tab');

        allTabButtons.forEach(btn => btn.classList.remove('active'));
        allTabs.forEach(tab => tab.classList.remove('show'));

        firstTabButton.classList.add('active');
        firstTab.classList.add('show');
      }
    }
  });
};

/* hasLinkMenuClose Close mobile menu on a#link clicked */
const hasLinkMenuClose = () => {
  if (document.querySelectorAll('.at-navigation-drawer .at-menu-back button[is="close-button"]').length > 0) {
    document.querySelectorAll('.text-with-icon[href*="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        // Trigger the close button if available
        const closeBtn = document.querySelector('.at-menu-back button[is="close-button"]');
        if (closeBtn) {
          closeBtn.click();
        }
      });
    });
  }
};


const setCartRefresh = () => {
  // document.dispatchEvent(new CustomEvent('cart:refresh'));
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
};

// Wait till page loaded, then only enable ATC button click.
const setBuyButtons = () => {
  setTimeout(function () {
    if (document.querySelectorAll('.product-info__buttons .buy-buttons').length > 0) {
      // console.log('Executed after 2 seconds');
      document.querySelector('.product-info__buttons .buy-buttons').classList.remove('disabled');
    }
  }, 500); // 500 ms = 0.5 seconds
};




// JS update prices when qty in changes on PDP page.
const setQtyPrice = () => {
  if (document.querySelectorAll('.product__price').length > 0) {
  const buttons = document.querySelectorAll('.quantity-selector__button');
  const quantityInput = document.querySelector('input[name="quantity"]');
  const priceElement = document.querySelector('.product__price'); // Adjust selector if needed
  const unitPrice = parseFloat(priceElement.dataset.unitprice); // Store base price from data attribute
  const moneyFormat = document.body.dataset.moneyFormat || '{{amount}}'; //
  buttons.forEach(button => {
    button.addEventListener('click', function () {
      // Trigger shared logic
      // console.log('quantityInput:', quantityInput);
      // console.log('priceElement:', priceElement);
      // console.log('unitPrice:', unitPrice);
      const qty = parseInt(quantityInput.value, 10) || 1;
      const newPrice = (unitPrice * qty).toFixed(2);
      // console.log('newPrice',newPrice);
      // priceElement.textContent = Shopify.formatMoney(newPrice, $('body').data('money-format'));
      priceElement.textContent = Shopify.formatMoney(newPrice, moneyFormat); // Update price display
    });
  });

  if (quantityInput && priceElement && unitPrice) {
    quantityInput.addEventListener('change', function () {
      const qty = parseInt(quantityInput.value, 10) || 1;
      const newPrice = (unitPrice * qty).toFixed(2);
      // console.log('newPrice',newPrice);
      priceElement.textContent = Shopify.formatMoney(newPrice, moneyFormat); // Update price display
    });
  }
  }
};


// Trigger on Variant change event
document.addEventListener('variant:change', function (event) {
  const variant = event.detail.variant; // Contains full variant object
  // console.log('Variant changed:', variant);
  
  setQtyPrice();
  // Example: update custom price
  // const customPriceEl = document.querySelector('.custom-price');
  // if (customPriceEl && variant) {
  //   customPriceEl.textContent = (variant.price / 100).toFixed(2) + ' €';
  // }
  // console.log('Variant changed: window.variantMetafields', window.variantMetafields );
  if (!variant || !variant.id) return;
  // Show the one that matches the current variant ID
  const availSpans = document.querySelectorAll('.product-info__block-item[data-block-type="available-from-date"] span.product-available_from');
  const matchedAvailSpan = document.querySelector(`.product-info__block-item[data-block-type="available-from-date"] span[data-vid="${variant.id}"]`);
  const hasContent = matchedAvailSpan.textContent.trim().length > 0;
  if (matchedAvailSpan && hasContent) {
    availSpans.forEach(function (span) {
      span.classList.add('hidden');
    });
    matchedAvailSpan.classList.remove('hidden');
  } else {
    availSpans.forEach(function (span) {
      span.classList.add('hidden');
    });
  }
});


  function removeDays_visualTimer() {
    console.log("removeDays_visualTimer");
    setTimeout(() => {
      const unwantedWords = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday","Sunday",","];
      const wrapper = document.getElementById('delivery_timer_wrapper1');
      if (wrapper) {
        wrapper.querySelectorAll('span').forEach(span => {
          let text = span.textContent;
          unwantedWords.forEach(word => {
            const regex = new RegExp(word, 'gi'); // g = global, i = case-insensitive
            text = text.replace(regex, '');
          });
          span.textContent = text.trim();
        });
        // console.log("Days_removed");
      }
    }, 5000);
  }
  
  const observer = new MutationObserver((mutations, obs) => {
    if (document.querySelector('.shopify-section--main-product .product .product-info .product-info__block-item #delivery_timer_wrapper1')) {
      obs.disconnect(); // Stop observing once the element is found
      // console.log("observer_timer");
      removeDays_visualTimer();
    }
  });
  
  // Start observing the document for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });


document.addEventListener('DOMContentLoaded', () => {
  attachEventListeners();
  setDefaultActiveMenu();
  setDefaultActiveTab();
  setMobileDefaultActiveTab();
  setDefaultCollectionProductActiveTab();
  setCartRefresh();
  setBuyButtons();
  setQtyPrice();
  hasLinkMenuClose();
});

// js/sections/at-desktop-mega-menu.js
import { timeline as timeline9, stagger as stagger5 } from "vendor";
var reduceMenuAnimation = window.themeVariables.settings.reduceMenuAnimation;
import { DropdownDisclosure } from "theme";
var AtMegaMenuDisclosure = class extends DropdownDisclosure {
  constructor() {
    super();
    this.addEventListener("pointerover", this._preloadImages.bind(this));
  }

  get mouseOverDelayTolerance() {
    return 500;
  }

  _transitionIn(hasOpenSiblings) {
    const timelineSequence = [
      [this.contentElement, { opacity: 1 }, { duration: 0.1 }],
      "at-mega-menu"
    ];
    const contentDelay = hasOpenSiblings ? 0.1 : 0;

    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches && !reduceMenuAnimation) {
      this.contentElement.querySelectorAll(".sub-child-menus-wrapper .child-submenu__nav").forEach((submenu) => {
        timelineSequence.push([
          submenu.querySelectorAll(":scope > *"),
          { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] },
          { easing: "ease", delay: stagger5(0.025, { start: contentDelay }), at: "at-mega-menu", duration: 0.1 }
        ]);
      });
      
      this.contentElement.querySelectorAll(".parent-submenu__nav > li").forEach((column) => {
        timelineSequence.push([
          column.querySelectorAll(":scope > :first-child, :scope li"),
          { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] },
          { easing: "ease", delay: stagger5(0.025, { start: contentDelay }), at: "at-mega-menu", duration: 0.1 }
        ]);
      });
    }

    return timeline9(timelineSequence).finished;
  }

  /**
   * When the toggle is hovered we preload the mega-menu images to improve perceived performance
   */
  _preloadImages() {
    Array.from(this.querySelectorAll('img[loading="lazy"]')).forEach((image) => image.setAttribute("loading", "eager"));
  }
};

if (!window.customElements.get("at-mega-menu-disclosure")) {
  window.customElements.define("at-mega-menu-disclosure", AtMegaMenuDisclosure, { extends: "details" });
}

// js/sections/at-mobile-menu.js
import { Delegate as Delegate6 } from "vendor";
import { Drawer } from "theme";
var AtNavigationDrawer = class extends Drawer {
  constructor() {
    super();
    const delegate = new Delegate6(this);
    delegate.on("click", "button[data-panel]", this._onPanelButtonClick.bind(this));
    this._isTransitioning = false;
    this.addEventListener("dialog:after-hide", () => {
      this.reinitializeDrawer();
    });
  }

  get openFrom() {
    return window.matchMedia("(max-width: 699px)").matches ? this.getAttribute("mobile-opening") : super.openFrom;
  }

  switchToPanel(panelIndex, linkListIndex = null) {
    const panels = this.querySelectorAll(".panel");
    let panelToHideTransform, panelToShowTransform, panelToHide = linkListIndex !== null ? panels[parseInt(panelIndex) - 1] : panels[parseInt(panelIndex) + 1], panelToShow = panels[panelIndex], linkLists = panelToShow.querySelectorAll(".panel__wrapper"), timelineSequence = [];
    
    if (document.dir === "rtl") {
      panelToHideTransform = linkListIndex !== null ? ["translateX(0%)", "translateX(100%)"] : ["translateX(0%)", "translateX(-100%)"];
      panelToShowTransform = linkListIndex !== null ? ["translateX(-100%)", "translateX(0%)"] : ["translateX(100%)", "translateX(0%)"];
    } else {
      panelToHideTransform = linkListIndex !== null ? ["translateX(0%)", "translateX(-100%)"] : ["translateX(0%)", "translateX(100%)"];
      panelToShowTransform = linkListIndex !== null ? ["translateX(100%)", "translateX(0%)"] : ["translateX(-100%)", "translateX(0%)"];
    }
    
    timelineSequence.push(
      [panelToHide, { transform: panelToHideTransform, opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.2, opacity: { at: "+0.3" }, transform: { at: "+0.3" } }],
      "panelHidden",
      [panelToShow, { opacity: [0, 1], visibility: ["hidden", "visible"], transform: panelToShowTransform }, { at: "<", transform: { duration: 0.3 } }]
    );

    if (linkListIndex !== null) {
      timelineSequence.push(this.switchLinkList(linkLists, linkListIndex));
    }

    timeline9(timelineSequence);
  }

  showPanel(panelIndex, linkListIndex = null) {
    const panels = this.querySelectorAll(".panel");
    let timelineSequence = [], panelToShow = panels[panelIndex], linkLists = panelToShow.querySelectorAll(".panel__wrapper");

    if (!panelToShow.hasAttribute("open") && !this._isTransitioning) {
      this._isTransitioning = true;
      timelineSequence.push(
        [this, { width: [this.offsetWidth + "px", (this.offsetWidth - parseInt(window.getComputedStyle(this).getPropertyValue("padding"))) * 2 + "px"] }, { duration: 0.1 }],
        [panelToShow, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { at: "<" }]
      );

      timelineSequence.push(this.switchLinkList(linkLists, linkListIndex));
    }

    if (this.previousLinkIndex && this.previousLinkIndex !== linkListIndex) {
      timelineSequence.push([linkLists[this.previousLinkIndex], { opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.1 }]);
    }

    timeline9(timelineSequence).finished.then(() => {
      if (this.previousLinkIndex && this.previousLinkIndex !== linkListIndex) {
        linkLists[this.previousLinkIndex].removeAttribute("style");
      }
      if (panelToShow.hasAttribute("open") && this.previousLinkIndex !== linkListIndex) {
        timeline9([this.switchLinkList(linkLists, linkListIndex)]);
      }
      this.previousLinkIndex = linkListIndex;
      panelToShow.setAttribute("open", "");
      this._isTransitioning = false;
    });
  }

  switchLinkList(linkLists, linkListIndex) {
    Array.from(linkLists).forEach((item) => {
      item.setAttribute("hidden", "");
    });
    linkLists[linkListIndex].removeAttribute("hidden");
    return [linkLists[linkListIndex].querySelectorAll("li"), { opacity: [0, 1], visibility: ["hidden", "visible"], transform: ["translateY(-10px)", "translateY(0)"] }, { easing: "ease", duration: 0.1, at: "-0.15", delay: stagger5(0.025, { start: 0.1 }) }];
  }

  reinitializeDrawer() {
    if (this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches) {
      this.style.removeProperty("width");
      this.setExpanded();
    } else {
      const firstPanel = this.querySelector(".panel:first-child");
      firstPanel.style.opacity = "1";
      firstPanel.style.visibility = "visible";
      firstPanel.style.transform = "translateX(0%)";
    }

    Array.from(this.querySelectorAll(".panel:not(:first-child)")).forEach((item) => {
      if (this.hasAttribute("mega-menu")) {
        item.removeAttribute("open");
      }
      item.style.opacity = "0";
      item.style.visibility = "hidden";
      Array.from(item.querySelectorAll(".panel__wrapper")).forEach((list) => list.setAttribute("hidden", ""));
    });
  }

  setExpanded(target) {
    Array.from(this.querySelectorAll("button[data-panel]")).forEach((item) => {
      item.setAttribute("aria-expanded", "false");
    });
    if (target) {
      target.setAttribute("aria-expanded", "true");
    }
  }

  _onPanelButtonClick(event, target) {
    if (this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches) {
      this.setExpanded(target);
      this.showPanel(...target.getAttribute("data-panel").split("-"));
    } else {
      this.switchToPanel(...target.getAttribute("data-panel").split("-"));
    }
  }
};

if (!window.customElements.get("at-navigation-drawer")) {
  window.customElements.define("at-navigation-drawer", AtNavigationDrawer);
}


// js/sections/at-custom-embedcode.js
var reduceMotion = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
import { animate as animate15, inView as inView11 } from "vendor";
var ATCustomEmbedCode = class extends HTMLElement {
  connectedCallback() {
    if (reduceMotion) {
      Array.from(this.querySelectorAll(".at-custom-embedcode_item")).forEach((item) => {
        inView11(item, (observer) => this.reveal(observer.target));
      });
    }
  }

  reveal(item) {
    const code = item.querySelector(".at-custom-embed-code");
    const content = item.querySelector(".at-custom-embedcode__content");
    const subContent = item.querySelector(".at-custom-embedcode__subcontent");

    animate15(code, { opacity: [0, 1] }, { duration: 0.3 });

    if (content) {
      animate15(content.querySelector(".prose"), { opacity: [0, 1] }, { duration: 0.2, delay: 0.3 });
    }
    
    if (subContent) {
      animate15(subContent.querySelector(".prose"), { opacity: [0, 1] }, { duration: 0.2, delay: 0.4 });
    }
  }
};
if (!window.customElements.get("at-custom-embedcode")) {
  window.customElements.define("at-custom-embedcode", ATCustomEmbedCode);
}

// js/common/at-mobile-localization-drawer.js
var AtMobileLocalizationDrawer = class extends Drawer {
  get shouldAppendToBody() {
    return false;
  }
  get openFrom() {
    return this.getAttribute("open-from") || "right";
  }
};
if (!window.customElements.get("at-mobile-localization-drawer")) {
  window.customElements.define("at-mobile-localization-drawer", AtMobileLocalizationDrawer);
}

// js/sections/at-multi-column-slider.js
import { timeline as timeline13 } from "vendor";
import { imageLoaded } from "theme";
var reduceMotion = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
var ATMultiColumnSlider = class extends HTMLElement {
  connectedCallback() {
    if (reduceMotion) {
      inView11(this, (observer) => this.reveal(observer.target));
    }
  }

  reveal(item) {
    const image = item.querySelector(".at-multi-column-slider__image");
    imageLoaded(image.querySelector("img")).then(() => {
      timeline13([
        [image, { opacity: [0, 1] }, { duration: 0.3 }],
        [image.querySelector("img"), { transform: ["scale(1.05)", "scale(1)"] }, { duration: 0.3, at: "<" }]
      ]);
    });
  }
};
if (!window.customElements.get("at-multi-column-slider")) {
  window.customElements.define("at-multi-column-slider", ATMultiColumnSlider);
}

// js/sections/at-multi-stacked-link.js
var reduceMotion = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
var ATMultiStackedLink = class extends HTMLElement {
  connectedCallback() {
    if (reduceMotion) {
      inView11(this, (observer) => this.reveal(observer.target));
    }
  }

  reveal(item) {
    const image = item.querySelector(".at-multi-stacked-link__image");
    imageLoaded(image.querySelector("img")).then(() => {
      timeline13([
        [image, { opacity: [0, 1] }, { duration: 0.3 }],
        [image.querySelector("img"), { transform: ["scale(1.05)", "scale(1)"] }, { duration: 0.3, at: "<" }]
      ]);
    });
  }
};
if (!window.customElements.get("at-multi-stacked-link")) {
  window.customElements.define("at-multi-stacked-link", ATMultiStackedLink);
}

// click to refresh the cart after adding & loading page.
document.addEventListener('DOMContentLoaded', function () {
  const cartUrl = `${Shopify.routes.root}cart.js`;
  const cartLink = document.querySelector(`.header a[href="${cartUrl}"]`);
  // console.log("Cart Link >",cartLink);
  //document.querySelector('a[href="/cart"]').addEventListener('click', function(event) {
  if (cartLink) {
    cartLink.addEventListener('click', function (event) {
      event.preventDefault(); // Optional: Prevent default navigation
      // console.log("Cart link clicked");
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      (typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.eventEmitter !== 'undefined' && typeof window.BOLD.common.eventEmitter.emit !== 'undefined' && (BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded')));
    });
  }
});


document.addEventListener('DOMContentLoaded', function () {
  
  //if( $('.tabs-nav__button').length > 0 )
  // if (document.querySelectorAll('.tabs-nav__button').length > 0) {
  //   // console.log("NEW -- ready!");
  //   const params = new URLSearchParams(window.location.search);
  //   const tabValue = parseInt(params.get('active_tab'), 10); // Convert to number
  //   // console.log(tabValue, 'tabValue');
  //   const tabs = $('.tabs-inner .tabs-nav__button');
  //   if (!isNaN(tabValue) && tabValue >= 1 && tabValue <= tabs.length) {
  //     tabs.eq(tabValue - 1).trigger('click'); // tabValue - 1 to match 0-based index
  //   }
  // }

  if (document.querySelectorAll('.tabs-nav__button').length > 0) {
    const params = new URLSearchParams(window.location.search);
    const tabValue = parseInt(params.get('active_tab'), 10); // Convert to number
    // 1. Replaced jQuery selector with native querySelectorAll
    const tabs = document.querySelectorAll('.tabs-inner .tabs-nav__button');
    if (!isNaN(tabValue) && tabValue >= 1 && tabValue <= tabs.length) {
      // 2. Replaced .eq() with standard array bracket notation [index]
      // 3. Replaced .trigger('click') with the native .click() method
      if (tabs[tabValue - 1]) {
        tabs[tabValue - 1].click();
      }
    }
  }

  // Cookie preference click to open popup.
  if (document.querySelectorAll('.isense-reopen-widget-button').length > 0) {
    const reopenPrefButton = document.querySelector('.isense-reopen-widget-button');
    if (reopenPrefButton) {
      reopenPrefButton.addEventListener('click', function (event) {
        // console.log('Reopen widget button clicked');
        showPreferences(this);event.preventDefault();
      });
    }
  }

  // Create QR to open chatbax directly. 
  const params = new URLSearchParams(window.location.search);
  if (params.get("chat") === "open") {
    const interval = setInterval(() => {
       // console.log('CHAT');
      if (window.GorgiasChat && GorgiasChat.open) {
        GorgiasChat.open();
        clearInterval(interval);
      }
    }, 100);
  }

});


/* trigger dots click for slider link */
  const waitForDots = setInterval(() => {
    const dots = document.querySelectorAll(
      ".slideshow__controls .numbered-dots__item"
    );
    if (dots.length > 0) {
      clearInterval(waitForDots);
      // console.log('test');
      const lastDot = dots[dots.length - 1];
      const firstDot = dots[0];
      if (lastDot && firstDot) {
        // Click last slide first
        lastDot.click();
        // Then quickly click first slide
        setTimeout(() => {
          firstDot.click();
        }, 50); // small delay is important
      }
    }
  }, 500);


// MOBILE: Review Tab - Accordion Logic | Target: a[href="#looxReviews"]
document.querySelectorAll('a[href="#looxReviews"]').forEach(function(button) {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    // Open 4th accordion inside .mobile_toggles
    const accordions = document.querySelectorAll('.mobile_toggles .accordion');
    const targetAccordion = accordions[3]; // 4th accordion
    if (targetAccordion && !targetAccordion.hasAttribute('open')) {
      targetAccordion.setAttribute('open', 'true');
      targetAccordion.setAttribute('aria-expanded', 'true');
      console.log('targetAccordion', targetAccordion);
      const content = targetAccordion.querySelector('.accordion__content');
      const toggleButton = targetAccordion.querySelector('.accordion__toggle');
      if (toggleButton) {
        toggleButton.click(); // Trigger the click event
      }
      if (content) {
        setTimeout(function() {
          content.style.opacity = '1';
          $(content).css({"maxHeight": content.scrollHeight + 'px'});
        }, 200);
      }
    }
    // Safely scroll to the accordion
    if (targetAccordion) {
      targetAccordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// DESKTOP: Review Tab Logic | Target: a[href="#looxReviewsFrame"]
document.querySelectorAll('a[href="#looxReviewsFrame"]').forEach(function(button) {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    // Open review tab
    const tabButtons = document.querySelectorAll('.tabs-nav__button');
    const reviewTab = tabButtons[3];
    const reviewSection = document.querySelector('#looxReviews');
    if (reviewTab) {
      reviewTab.click();
      reviewTab.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(() => {
        if (reviewSection) {
          reviewSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 500);
    }
  });
});


// open modal when clicked on product TUV Certifications
document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelectorAll('.open-tuv-modal').length > 0) {
    // console.log('Dom Loaded...');
    // Select all modal open buttons
    const openButtons = document.querySelectorAll(".open-tuv-modal");
    // console.log('click',openButtons);
    openButtons.forEach((btn) => {
      btn.addEventListener("click", function () {
        // console.log('button click', btn);
        // Find the modal right next to this button
        const modal = btn.parentElement.querySelector(".tuv-document-modal");
        // console.log('modal',modal);
        if (modal) {
          modal.style.display = "block";
          // Find the close button inside THIS modal
          const closeBtn = modal.querySelector(".tuv-close");
          if (closeBtn) {
            closeBtn.addEventListener("click", function () {
              modal.style.display = "none";
            });
          }
          // Also close when clicking outside modal content
          modal.addEventListener("click", function (event) {
            if (event.target === modal) {
              modal.style.display = "none";
            }
          });
        }
      });
    });
  }
});

export {
  AtMegaMenuDisclosure,
  AtNavigationDrawer,
  ATCustomEmbedCode,
  AtMobileLocalizationDrawer,
  ATMultiColumnSlider,
  ATMultiStackedLink
};